import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Module } from '../../modules/module';
import { UserSessionService } from '../../app-user-session.service';
import { dashboardComponent } from '../../dashboard/dashboard.component';
import { FavoriteService, Favorite } from '../../security/favorite';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ModuleService } from '../../modules/module.service';


@Component({
  selector: 'app-sec-login-favourite-setting',
  templateUrl: './sec-login-favourite-setting.component.html',
  styleUrls: ['./sec-login-favourite-setting.component.css']
})
export class SecLoginFavouriteSettingComponent implements OnInit {
  @ViewChild('dashboardComponent') dashboardComponent: dashboardComponent;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  //favoriteObj: Favorite[] = [];
  constructor(private route: ActivatedRoute,
    private _userSessionService: UserSessionService,
    private _moduleService: ModuleService,
    private _favouriteService: FavoriteService) { }
  favoLinks: Favorite[] = [];

  ngOnInit() {
    this.getFavArea();
  }
  getFavArea() {
    this._moduleService
      .getSubModulesTypes(0, 5).pipe(
        takeUntil(this.ngUnsubscribe))
      .subscribe(c => {
        let favoLinks = c.data;
        this._userSessionService.setSessionKey('toggleFavArea', favoLinks);

      });
    this.favoLinks = this._userSessionService.getSessionKey('toggleFavArea');

  }
  onBtnSave(operation: number) {
    switch (operation) {
      case 1:
      case -1000: // shortCut code
        this.saveFavoriteData();
        break;
      default:
        console.warn('No Details Save Action');
        break;
    }
  }
  onLinkClicked(link: Module, event: Event) {
    this.dashboardComponent.onLinkClicked(link, event);
  }
  // onFavourite(module: any,datastatus:number) {
  //   this.dashboardComponent.onFavourite(module,datastatus)
  // }
  ondeleteFavourite(module: any, datastatus: number) {

    const currentFavModule = <Favorite>{
      secLoginId: this._userSessionService.secLoginId,
      linkId: module.code,
      serial: module.favSerial,
      dataStatus: datastatus
    };

    this._favouriteService
      .deleteFavorite(currentFavModule).pipe(
        takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          module['isFav'] = 0;
          this.getFavArea();
        },
        error => console.log(error),
        () => { }
      );

  }

  saveFavoriteData() {
    this.favoLinks.forEach(element => {
      element.linkId = element['code'];
    });
    this._favouriteService
      .addMultiFavoritelinks(this.favoLinks)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        if (res.returnFlag == true) {
          this.getFavArea();
        }
      });
  }

}

